export const isMultipleChoiceResult = (result) =>
  result?.questionType === "multipleChoice" && result?.mcqResult;

export const formatResultOption = (option, fallback = "") =>
  option ? `${option.label}. ${option.text}` : fallback;

export const selectedResultAnswer = (result) => {
  if (!isMultipleChoiceResult(result)) return String(result?.userAnswer ?? "");
  if (result.mcqResult.selectedOption) return formatResultOption(result.mcqResult.selectedOption);
  return result.mcqResult.selectedAnswerUnavailable
    ? "Submitted answer unavailable"
    : "No answer provided";
};

export const correctResultAnswer = (result) => {
  if (!isMultipleChoiceResult(result)) return String(result?.markSchemeAnswer ?? "");
  return formatResultOption(result.mcqResult.correctOption);
};

export const resultOptionsMatch = (selected, correct) =>
  Boolean(
    selected && correct &&
    selected.label === correct.label &&
    selected.text === correct.text
  );
